import { useContext } from 'react';
import Face4OutlinedIcon from '@mui/icons-material/Face4Outlined';
import uuid from 'react-uuid';
import Tooltip from './Tooltip';
import { Auth } from '../../StateManagment/Auth';
import { DeccaContext } from '../../StateManagment/DeccaContext.js';
import { db, timestamp } from '../../firebase/config.js';
import { useFirestoreOrderBy } from '../../firebase/useFirestore.js';
import { client } from '../../hooks/Client';
import newConversation from '../../agents/newConversation.js';

const DeccaTriggerButton = ({
    subject,
    label = 'Vraag Decca om advies',
    contextData = '',
    greeting,
    tenantOverride = null,
    tenantNameOverride = null,
}) => {
    const [auth] = useContext(Auth);
    const {
        setChatOpen,
        setSelectedConversationID,
        setShowConversations,
        setSubject,
        setContextData,
        setTenantOverride,
        setTenantNameOverride,
    } = useContext(DeccaContext);

    const conversations = useFirestoreOrderBy('Conversations', 'Position', 'desc');

    const handleClick = async () => {
        const conversationID = uuid();
        const title = `Gesprek over ${subject}`;
        const message = greeting
            || `<h2>Hallo ${auth.ForName}</h2><p>Zal ik een voorstel doen over wat je bij ${subject} in kan vullen?</p>`;

        setSubject(subject);
        setChatOpen(true);
        setContextData(contextData);
        // Always set explicitly — clears any prior override when this button doesn't pass one
        setTenantOverride(tenantOverride || null);
        setTenantNameOverride(tenantNameOverride || null);

        await newConversation(
            conversationID,
            title,
            message,
            conversations.length + 1,
            client,
            timestamp,
            uuid(),
            auth.ID,
            auth.ForName,
            db,
        );

        setSelectedConversationID(conversationID);
        setShowConversations(false);
    };

    return (
        <div className="decca-trigger-button" onClick={handleClick}>
            <div className="decca-trigger-button__inner">
                <Tooltip content="Open Decca" top="-35px" width="30px">
                    <Face4OutlinedIcon />
                </Tooltip>
                <p>{label}</p>
            </div>
        </div>
    );
};

export default DeccaTriggerButton;
